export default "__VITE_ASSET__d344d77d__"